import type { FC } from "react";
import { checkNiceCxoneIntegrationEnabled } from "../../integrations/integrationsSlice.js";
import { integrationConfigs, NICE_CXONE_SLUG } from "./integrationConfigs.js";
import { useNiceCxoneDetailOutletContext } from "./niceCxoneIntegrationDetailSection.js";

const config = integrationConfigs.find(
  (entry) => entry.slug === NICE_CXONE_SLUG,
);

/**
 * The "NICE CXone" Settings tab. Nothing is editable or shown beyond the
 * pause state: Alpharun holds the credentials and agent list and changes them
 * on request.
 */
export const NiceCxoneSettingsTab: FC = () => {
  const { integration } = useNiceCxoneDetailOutletContext();

  return (
    <div className="max-w-3xl space-y-6">
      <p className="text-sm leading-6 text-muted-foreground">
        {config?.description}
      </p>

      {!checkNiceCxoneIntegrationEnabled(integration) ? (
        <div className="rounded-md bg-amber-50 p-3 text-sm text-amber-800">
          Imports are currently paused by Alpharun.
        </div>
      ) : null}

      <p className="text-sm leading-6 text-muted-foreground">
        This integration is managed by Alpharun. To change which agents are
        imported or update your NICE CXone credentials, contact your Alpharun
        team.
      </p>
    </div>
  );
};
